<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg390"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs394"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath422"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path420" /></clipPath></defs><g
     id="g396"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g398"
       transform="translate(90,296)"><path
         d="M 0,0 H 36 L 7.234,-80"
         style="fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path400" /></g><path
       d="M 166,172 H 50 v 168 h 116 z"
       style="fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
       id="path402" /><g
       id="g404"
       transform="translate(206,296)"><path
         d="M 0,0 H 36 L 7.234,-80"
         style="fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path406" /></g><path
       d="M 282,172 H 166 v 168 h 116 z"
       style="fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
       id="path408" /><g
       id="g410"
       transform="translate(322,296)"><path
         d="M 0,0 H 36 L 7.234,-80"
         style="fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path412" /></g><path
       d="M 398,172 H 282 v 168 h 116 z"
       style="fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
       id="path414" /><g
       id="g416"><g
         id="g418"
         clip-path="url(#clipPath422)"><g
           id="g424"
           transform="translate(394.0917,380)"><path
             d="M 0,0 C -23.971,70.933 -91.067,122 -170.092,122 -249.116,122 -316.213,70.933 -340.183,0"
             style="fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path426" /></g><g
           id="g428"
           transform="translate(478,448)"><path
             d="m 0,0 v -160.814 c 0,-17.293 -14.02,-31.313 -31.314,-31.313 H -40"
             style="fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path430" /></g><g
           id="g432"
           transform="translate(502,478)"><path
             d="m 0,0 c 0,13.255 -10.745,24 -24,24 -13.255,0 -24,-10.745 -24,-24 0,-13.255 10.745,-24 24,-24 13.255,0 24,10.745 24,24 z"
             style="fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path434" /></g><g
           id="g436"
           transform="translate(269.0003,380)"><path
             d="M 0,0 H 169 V -248 H -259 V 0 h 168.999"
             style="fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path438" /></g><path
           d="M 398,132 H 50 V 10 h 348 z"
           style="fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path440" /><g
           id="g442"
           transform="translate(112.3333,71)"><path
             d="M 0,0 H 223.333"
             style="fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path444" /></g><g
           id="g446"
           transform="translate(224,380)"><path
             d="M 0,0 V 0"
             style="fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path448" /></g></g></g></g></svg>
</template>
